import {createContext, useContext} from 'react'

export const TreeDocContext = createContext()
export const useTreeDocContext = () => useContext(TreeDocContext)
